import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/theme';
import GlobalStyles from './styles/GlobalStyles';
import { LanguageProvider } from './context/LanguageContext';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HtmlLangUpdater from './components/HtmlLangUpdater';
import CookieBanner from './components/CookieBanner';

// Pages
import Home from './pages/Home';
import Rooms from './pages/Rooms';
import BusinessStay from './pages/BusinessStay';
import Restaurant from './pages/Restaurant';
// Brasserie page removed as requested
import Region from './pages/Region';
import Contact from './pages/Contact';
import LegalNotice from './pages/LegalNotice';

// Synchronize context language with URL
function LanguageSync({ children }) {
  const { lang } = useParams();
  const { language, changeLanguage } = require('./context/LanguageContext').useLanguage();
  
  React.useEffect(() => {
    if (lang && lang !== language) {
      changeLanguage(lang);
    }
  }, [lang, language, changeLanguage]);
  
  return (
    <>
      <HtmlLangUpdater />
      {children}
    </>
  );
}


function App() {
  return (
    <LanguageProvider>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <Router>
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              {/* Redirect / to /fr/ by default */}
              <Route path="/" element={<Navigate to="/fr/" replace />} />
              
              {/* Routes pour le français */}
              <Route path="fr/" element={
                <LanguageSync>
                  <Home />
                </LanguageSync>
              } />
              <Route path="fr/chambres" element={
                <LanguageSync>
                  <Rooms />
                </LanguageSync>
              } />
              <Route path="fr/soirees-etapes" element={
                <LanguageSync>
                  <BusinessStay />
                </LanguageSync>
              } />
              <Route path="fr/restaurant" element={
                <LanguageSync>
                  <Restaurant />
                </LanguageSync>
              } />
              <Route path="fr/alentours" element={
                <LanguageSync>
                  <Region />
                </LanguageSync>
              } />
              <Route path="fr/contact" element={
                <LanguageSync>
                  <Contact />
                </LanguageSync>
              } />
              <Route path="fr/mentions-legales" element={
                <LanguageSync>
                  <LegalNotice />
                </LanguageSync>
              } />
              <Route path="fr/*" element={<Navigate to="/fr/" replace />} />
              
              {/* Routes pour l'anglais - avec URLs traduites */}
              <Route path="en/" element={
                <LanguageSync>
                  <Home />
                </LanguageSync>
              } />
              <Route path="en/rooms" element={
                <LanguageSync>
                  <Rooms />
                </LanguageSync>
              } />
              <Route path="en/business-stays" element={
                <LanguageSync>
                  <BusinessStay />
                </LanguageSync>
              } />
              <Route path="en/restaurant" element={
                <LanguageSync>
                  <Restaurant />
                </LanguageSync>
              } />
              <Route path="en/surroundings" element={
                <LanguageSync>
                  <Region />
                </LanguageSync>
              } />
              <Route path="en/contact" element={
                <LanguageSync>
                  <Contact />
                </LanguageSync>
              } />
              <Route path="en/legal-notice" element={
                <LanguageSync>
                  <LegalNotice />
                </LanguageSync>
              } />
              <Route path="en/*" element={<Navigate to="/en/" replace />} />
              
              {/* Routes de compatibilité pour les anciennes URLs en anglais */}
              <Route path="en/chambres" element={<Navigate to="/en/rooms" replace />} />
              <Route path="en/alentours" element={<Navigate to="/en/surroundings" replace />} />
              <Route path="en/mentions-legales" element={<Navigate to="/en/legal-notice" replace />} />
              
              {/* Rediriger toutes les autres routes vers la page d'accueil par défaut */}
              <Route path="*" element={<Navigate to="/fr/" replace />} />
            </Routes>
          </main>
          <Footer />
          <CookieBanner />
        </Router>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
